import { type ReactElement } from 'react';

import styles from './score-detail.module.scss';
import { Font } from '@utmb/design-system/text/font';

export interface ScoreDetailProps {
    /** Reference score the percentage is computed from (base score for the adjusted score, best score for the DBS). */
    referenceScore: number;
    /** Resulting score after degradation. */
    score: number;
    /** Greyed out when this score is not the one retained for the index. */
    isDisabled?: boolean;
}

function formatPct(value: number): string {
    const rounded = Math.round(value * 10) / 10;
    return rounded.toLocaleString('fr-FR', { maximumFractionDigits: 1 });
}

export function ScoreDetail({ referenceScore, score, isDisabled = false }: ScoreDetailProps): ReactElement {
    const deltaPct = referenceScore > 0 ? (score / referenceScore - 1) * 100 : 0;
    const isBonus = deltaPct >= 0;

    return (
        <div className={styles.scoreDetail + ' ' + (isDisabled ? styles.disable : '')}>
            <Font.FuturaMedium desktop="12" mobile="12" className={styles.detail + ' ' + (isBonus ? styles.bonus : styles.malus)}>
                {Math.round(referenceScore)} {isBonus ? '+' : '-'} {formatPct(Math.abs(deltaPct))}%
            </Font.FuturaMedium>
            <Font.OxaniumMedium className={styles.score} desktop="32" mobile="32">
                {Math.round(score)}
            </Font.OxaniumMedium>
        </div>
    );
}
